export default "__VITE_ASSET__CvhbYUx___"